import React, { useEffect } from 'react';

import { Box } from '@rbilabs/universal-components';

import { ILocation } from '@rbi-ctg/frontend';
import useMap from 'hooks/use-map';
import { CenterPoint, MarkerTypes } from 'hooks/use-map/types';
import noop from 'utils/noop';

interface IStaticMap {
  initialZoomAndroid?: number;
  initialZoomIOS?: number;
  position: ILocation;
  title?: string;
  enablePointerEvents?: boolean;
}

const StaticMap: React.FC<React.PropsWithChildren<IStaticMap>> = ({
  initialZoomAndroid,
  initialZoomIOS,
  position,
  title,
  enablePointerEvents = false,
}) => {
  const { map, createMarker } = useMap({
    initialZoomAndroid,
    initialZoomIOS,
    position: position as CenterPoint,
    isStaticMap: true,
  });

  useEffect(() => {
    // TODO: RN - Define type for location-pin-active.png
    createMarker({
      id: 'store',
      type: MarkerTypes.StoreFocused,
      location: position as CenterPoint,
      onPress: noop,
      title,
    });
  }, [createMarker, position, title]);

  return (
    <Box flex="1" pointerEvents={enablePointerEvents ? 'auto' : 'none'}>
      {map}
    </Box>
  );
};

export default StaticMap;
